import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./SkillLogin.css";

const SkillLogin = () => {
  const navigate = useNavigate();

  const closeModal = () => {
    navigate(-1); // Go back to the previous route
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        closeModal();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);

  return (
    <div className="modal-overlay" onClick={closeModal}>
      <div className="modal-box" onClick={(e) => e.stopPropagation()}>
        <button className="close-btn" onClick={closeModal}>✖</button>

        <h2 className="modal-title">LOGIN</h2>
        <p className="modal-subtitle">
          Choose your login type to continue
        </p>

        <div className="toggle-tabs">
          <button
            className="submit-btn"
            onClick={() => window.location.href = "https://jobs.skillshap.com/candidate/login"}
          >
            Candidate Login
          </button>

          <button
            className="submit-btn"
            onClick={() => window.location.href = "https://jobs.skillshap.com/employer/account/login"}
          >
           Recruiter Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default SkillLogin;